import { createSelector } from 'reselect';

import { getBulkEditSelectedIds, getComponentProps } from './common.selectors';

export const isRecordSelected = createSelector(
  [getBulkEditSelectedIds, getComponentProps],
  (selectedIds, { id }) => selectedIds.includes(id)
);

export const isAllRowsPerPageSelected = createSelector(
  [getBulkEditSelectedIds, getComponentProps],
  (selectedIds, { allRowsPerPage }) => {
    if (!allRowsPerPage.length) {
      return false;
    }
    return allRowsPerPage.every((row) => selectedIds.includes(row[row.PrimaryKeyColumn]));
  }
);

export const isSelectedRecordOnCurrentPage = createSelector(
  [getBulkEditSelectedIds, getComponentProps],
  (selectedIds, { allRowsPerPage }) =>
    allRowsPerPage.find((row) => selectedIds.includes(row[row.PrimaryKeyColumn]))
);
